import { render, staticRenderFns } from "./professionalArticlesDetail.vue?vue&type=template&id=c99e3840&scoped=true&"
import script from "./professionalArticlesDetail.vue?vue&type=script&lang=js&"
export * from "./professionalArticlesDetail.vue?vue&type=script&lang=js&"
import style0 from "./professionalArticlesDetail.vue?vue&type=style&index=0&id=c99e3840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99e3840",
  null
  
)

export default component.exports